import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { createContext, useState } from 'react';
import PropTypes from "prop-types";
import Pager from "../../data/Pager";
import * as stylex from '@stylexjs/stylex';
export var TwoColumnContainerContext = /*#__PURE__*/createContext(null);
export default function TwoColumnContainer(props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    form_obj = _useState2[0],
    set_form_obj = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    valid = _useState4[0],
    set_valid = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    processing = _useState6[0],
    set_processing = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    e = _useState8[0],
    set_e = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    s = _useState0[0],
    set_s = _useState0[1];
  var _useState1 = useState(new Pager({
      n: 10
    })),
    _useState10 = _slicedToArray(_useState1, 2),
    pager = _useState10[0],
    set_pager = _useState10[1];
  return /*#__PURE__*/React.createElement(TwoColumnContainerContext.Provider, {
    value: {
      form_obj: form_obj,
      set_form_obj: set_form_obj,
      valid: valid,
      set_valid: set_valid,
      processing: processing,
      set_processing: set_processing,
      pager: pager,
      set_pager: set_pager,
      set_s: set_s,
      s: s,
      set_e: set_e,
      e: e
    }
  }, props.for_three_column ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      height: '100%',
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      border: '0px dotted red'
    }
  }, props.content_center), /*#__PURE__*/React.createElement("div", _extends({
    className: 'ui-search-col'
  }, {
    className: "TwoColumnContainer__ui.searchPane evdzyupr evy3k0t6 ev1qhigcl evls6w5y ev1yuvlll"
  }), props.content_right)) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      height: '100%',
      justifyContent: 'flex-end',
      alignContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      border: '0 dotted red',
      width: '100%'
    }
  }, props.content_center), /*#__PURE__*/React.createElement("div", {
    className: 'ui-search-col',
    style: {
      borderLeft: '1px solid #ccc'
    }
  }, props.content_right)));
}
TwoColumnContainer.propTypes = {
  content_center: PropTypes.any,
  content_right: PropTypes.any,
  has_right_column: PropTypes.bool,
  for_three_column: PropTypes.bool
};
_inject(".evdzyupr{width:300px}", 4000);
_inject("@media (max-width:599px){.evy3k0t6.evy3k0t6{width:0}}", 4200);
_inject(".ev1qhigcl{padding:20px}", 1000);
_inject("@media (max-width:599px){.evls6w5y.evls6w5y{padding:0}}", 1200);
_inject(".ev1yuvlll{border-left:1px solid var(--shade-10)}", 2000);